/**
 * Helper functions for parent context in BRC templates
 */

const PARDOT_SAVE_FORM_ENDPOINT = 'brc/api/pardot/save-form-data';

/**
 * Returns the props needed for the ParentProvider component
 * @param {Object} options - The options for generating parent provider props
 * @param {Object} options.fpti - FPTI tracking object
 * @param {Object} options.pageInfo - Page information object
 * @param {boolean} options.isBrowserEnv - Whether the code is running in a browser environment
 * @returns {Object} - Props for the ParentProvider component
 */
const getParentProviderProps = ({
  fpti,
  pageInfo = {},
  nonce,
  isBrowserEnv = false,
}) => ({
  cmsEngineContext: {
    apis: {
      pardot: {
        saveFormData: `/${pageInfo?.locality?.country?.toLowerCase() || 'us'}/${PARDOT_SAVE_FORM_ENDPOINT}`,
      },
    },
    app: {
      appEntryPoint: pageInfo.resourceHub === 'BRC' ? 'brc/' : 'money-hub/',
    },
    environment: {
      // Don't add "host" property as that's used to format our relative URLs from
      // pp-com-components side. And this is something we don't want since we already
      // format our URLs using the "linkResolver" fn.
      isCMSPreview: pageInfo.isCMSPreview,
      runMode: pageInfo.runMode,
      baseURI: pageInfo.baseURI,
      baseNolocaleUri: pageInfo.baseNoLocaleUri,
      pageURI: pageInfo.pageURI,
      pageSegment: pageInfo.pageSegment,
      queryStringParams: pageInfo.queryStringParams,
      theme: pageInfo.theme ?? 'regular',
      reduceMotion: pageInfo.reduceMotion,
    },
    requestor: {
      userHome: 'NONE',
      tracking: {
        fpti: isBrowserEnv ? fpti : {},
      },
      encryptedAccountNum: '',
      csrfToken: pageInfo.csrf,
      loggedIn: pageInfo.isLoggedIn,
      locality: pageInfo.locality,
      nonce,
    },
  },
  componentKitContext: {},
  additionalContext: {},
});

module.exports = { getParentProviderProps };
